module.exports = __webpack_public_path__ + "static/media/enemy.b07bdeeb.png";